import { render, staticRenderFns } from "./SlowMovingLocationItem.vue?vue&type=template&id=182af456&"
import script from "./SlowMovingLocationItem.vue?vue&type=script&lang=js&"
export * from "./SlowMovingLocationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports